import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../index.css";
import { useAuth } from "../contexts/AuthContext";
import {
  ShoppingBag
} from "lucide-react";

function Header({ cartItems }) {
  const [open, setOpen] = useState(false);
  const menu = useRef();
  const { currentUser, logout } = useAuth();

  function openMenu() {
    setOpen(!open);
  }

  function closeMenu() {
    setOpen(false);
  }

  const itemCount = cartItems ? Object.values(cartItems)
    .reduce((sum, item) => sum + item.quantity, 0) : 0;

  return (
    <div id="header">
      <div id="header-left">
        <div id="header-left-primary">
          <button id="menu-btn">
            <img src="/images/menu.svg" alt="menu" onClick={openMenu} />
          </button>
          <h1>Qwytt</h1>
        </div>
        <Link to="/checkout">
          <button id="header-cart-sm">
            <ShoppingBag></ShoppingBag>
            <h3>{itemCount}</h3>
          </button>
        </Link>
      </div>
      <div
        id="header-right-sm"
        ref={menu}
        style={{ height: open ? "14em" : "0em", width: open ? "70vw" : "0em" }}
      >
        <Link to="/" onClick={closeMenu}>
          <button className="header-button">How It Works</button>
        </Link>
        <Link to="/research" onClick={closeMenu}>
          <button className="header-button">Research</button>
        </Link>
        <Link to="/reserve" onClick={closeMenu}>
          <button className="header-button" id="header-cta">Pre-Order</button>
        </Link>
        {!currentUser && (
          <Link to="/login" onClick={closeMenu}>
            <button className="header-button">Login</button>
          </Link>
        )}
        {currentUser && (
          <Link to="/account" onClick={closeMenu}>
            <button className="header-button">Account</button>
          </Link>
        )}
        {currentUser && (
          <Link to="/" onClick={() => { closeMenu(); logout(); }}>
            <button className="header-button">Sign Out</button>
          </Link>
        )}
      </div>
      <div id="header-right" ref={menu}>
        <Link to="/">
          <button className="header-button">How It Works</button>
        </Link>
        <Link to="/research">
          <button className="header-button">Research</button>
        </Link>
        <Link to="/reserve">
          <button className="header-button" id="header-cta">Pre-Order</button>
        </Link>
        {!currentUser && (
          <Link to="/login">
            <button className="header-button">Login</button>
          </Link>
        )}
        {currentUser && (
          <Link to="/account">
            <button className="header-button">Account</button>
          </Link>
        )}
        {currentUser && (
          <Link to="/" onClick={logout}>
            <button className="header-button">Sign Out</button>
          </Link>
        )}
        <Link to="/checkout">
          <button id="header-cart">
            <ShoppingBag></ShoppingBag>
            <h3>{itemCount}</h3>
          </button>
        </Link>
      </div>
    </div>
  );
}

export default Header;